/**
 * Compatibility shim for vee-validate v2/v3 ValidationProvider.
 * In vee-validate v4, this was replaced by <Field>.
 * This shim provides the old slot API ({ errors, valid, pending, ... })
 * so existing templates work without modification. Client-side validation
 * is skipped; server-side validation still applies.
 */
export default {
	name: 'ValidationProvider',
	props: {
		name: String,
		rules: [String, Object],
		vid: String,
	},
	setup(props, { slots }) {
		return () => slots.default?.({
			errors: [],
			valid: true,
			dirty: false,
			touched: false,
			validated: false,
			pending: false,
			required: false,
		});
	},
};
